import React, { Component } from 'react';
import 'materialize-css/dist/css/materialize.min.css';
import '../Css/Style.css';
import {getData} from '../Api/Config';
import CirclePreloader from '../layouts/CirclePreloader';
import {Link} from 'react-router-dom';
import Badges from './Badges';

class AppDetails extends Component{
  state = {
    data:[],
    isloader:false,
    statusBox:['ICE_BOX','TODO','IN_PROGRESS','IN_REVIEW','COMPLETED','LIVE'],
    colorBox:['#03a9f4','#00e676','#ffb300','#ff3d00','#64dd17','#ff1744']
}

  componentDidMount(){
    this.GetAppDetails();
  }

  GetAppDetails=()=>{
    this.setState({isloader:true})
    getData('apps').then(res=> { 
      if(res.applications){
        this.setState({data:res.applications}) 
      }
      // console.log(res);
      this.setState({isloader:false})
    }).catch(err=>{
      this.setState({isloader:false})
      console.log(err)
    });
  }  

  filteredApps=(Id)=>{

    const appDetailsByPublisher = this.state.AppDatas.filter(retrive=>{return retrive.Publisher.id===Id });
    return appDetailsByPublisher;
  }

    render(){
        const {colorBox,statusBox} = this.state;

        const appView = this.state.data && [...this.state.data].map(publisher=>{
            return(
            <div className="card" key={publisher.publisherId} style={{marginTop:10,marginRight:0}}>
               <div className="card-panel blue-grey white-text">{publisher.publisherName}</div>
              
               <div className="card-content">
                <div className="row">
                  {publisher.applications && [...publisher.applications].map((app)=>{
                    return (
                      
                      <div key={app.id}>
                      <Link to={`AppDetail/${app.id}/${publisher.publisherId}`} >
                      <div className="col s12 m3">
                   
                      <div className="card sticky-action hoverable" style={{maxWidth:'180px'}}>
                     <div className="card-image waves-effect waves-block waves-light">
                            <img alt={app.id} src={app.logoUrl}/>
                    </div>
                    <span className="badge white-text" style={{background:colorBox[statusBox.indexOf(app.status)]}}>{app.status}</span>
                      <div className="card-content ">
                     
                       <p className="truncate black-text">{app.name}</p>
                       <p className="truncate black-text">{publisher.publisherName}</p>
                       {app.platform==='ANDROID'?(
                            <span className="btn-floating halfway-fab waves-effect waves-light white"><img style={{marginLeft: '-3px'}} alt={app.platform} className="center" src="https://img.icons8.com/color/48/000000/android-os.png"/></span>
                      ):(
                        <span className="btn-floating halfway-fab waves-effect waves-light white"><img alt={app.platform} style={{marginLeft: '-3px'}} className="center" src="https://img.icons8.com/color/48/000000/apple-app-store.png"/></span>
                      )}
                     
                      </div> 
                      
                     </div>

                     
                      </div>
                       </Link>
                      </div>
                    )
                }
                )
                }
                </div>
           </div>
            </div>
           
          
            )
        })


        return(
            <div>
              <Badges/>
                <h6>Apps Lists</h6>
               { this.state.isloader?<CirclePreloader/>:appView}   
            </div>
        )
    }
   
}
export default AppDetails;